import React, { FC, ReactElement, useState } from 'react';

import { UploadCloudIcon } from 'lucide-react';
import { observer } from 'mobx-react-lite';
import { useCommon } from 'src/AppState/Common';
import { DnDAreaState } from 'src/components/Uploader/DnDArea.state';
import { cn } from 'src/domains/common/components/utils';
import { Button } from 'src/domains/common/components/button/button';
import { UploadCSVState } from 'src/domains/casino/webview/bonus-engine/campaign/player-management/eligible-users/upload-area/UploadCSV.state';

interface UploadCSVPropsType {
    label: string;
    uploadState: UploadCSVState;
    disabled: boolean;
}

export const UploadCSV: FC<UploadCSVPropsType> = observer(({ label, disabled, uploadState }): ReactElement => {
    const common = useCommon();
    const { allowedMimeTypes, allowedFileTypes, setInputRef, handleFileDrop, handleClick, handleFileSelect } =
        uploadState;
    const [state] = useState(() => new DnDAreaState(handleFileDrop, allowedMimeTypes, common));

    return (
        <div
            className={cn(
                'flex flex-col items-center rounded-md border border-dashed border-neutral-200 p-6 gap-3',
                disabled && 'pointer-events-none opacity-50 cursor-not-allowed',
                state.isFileOver && 'bg-stone-50'
            )}
            onDragEnter={state.highlightArea}
            onDragOver={state.highlightArea}
            onDragLeave={state.restoreArea}
            onDrop={state.handleDrop}
        >
            <div className='flex items-center gap-2'>
                <UploadCloudIcon className='stroke-1 size-4' />
                <span className='font-semibold leading-[1.25]'>{label}</span>
            </div>
            <Button
                onClick={handleClick}
                variant='link'
                disabled={disabled}
                className='h-5 p-0 font-normal underline'
            >
                Or select a file from your computer
            </Button>
            <input
                type='file'
                accept={allowedFileTypes.toString()}
                className='hidden'
                ref={setInputRef}
                onChange={handleFileSelect}
                disabled={disabled}
            />
        </div>
    );
});
